import { getTenantFromPath } from '../tenant.js';

/**
 * Prefix SWR keys with the active route tenant so inactive-tenant cache
 * entries do not stay subscribed / revalidated after a tenant switch.
 * Dev / platform routes (no tenant in path) use the `platform` scope.
 *
 * Prefer passing `routeTenantCode` from `useParams` so the key updates on the
 * same render as the route change (module override alone can lag one frame).
 */
export function withAdminSwrTenantKey(
  key: string | null,
  routeTenantCode?: string | null,
): string | null {
  if (key === null) {
    return null;
  }
  const fromRoute = routeTenantCode?.trim();
  if (fromRoute !== undefined && fromRoute.length > 0) {
    return `${fromRoute}:${key}`;
  }
  return `${adminSwrTenantScope()}:${key}`;
}

export function adminSwrTenantScope(routeTenantCode?: string | null): string {
  const fromRoute = routeTenantCode?.trim();
  if (fromRoute !== undefined && fromRoute.length > 0) {
    return fromRoute;
  }
  const tenant = getTenantFromPath();
  if (tenant !== null && tenant.length > 0) {
    return tenant;
  }
  return 'platform';
}
